import React, { useEffect } from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch } from 'react-redux';
import { updateBackdropState } from 'actions/admin/config';
import { useSelector } from 'react-redux';
import { Card } from '@material-ui/core';
import colors from 'config/colors';

const useStyles = makeStyles(theme => ({
  backdrop: {
    marginTop: -10,
    zIndex: theme.zIndex.drawer + 1,
    color: colors.grey2,
    background: 'transparent',
  },
  card: {
    borderRadius: '50%',
    backgroundColor: colors.appPrimaryColor,
    color: theme.palette.primary.contrastText,
    padding: 10,
    paddingBottom: 4,
  },
}));
let timer;
export default function AppBackdrop({ isOpen = false }) {
  const classes = useStyles();
  const isBackdropOpen = useSelector(state => state.config.isBackdropOpen);
  const dispatch = useDispatch();

  useEffect(() => {
    timer = setTimeout(() => {
      if (isBackdropOpen || isOpen) {
        dispatch(updateBackdropState(false));
      }
    }, 3000);
    return () => {
      clearTimeout(timer);
    };
  }, [isBackdropOpen, isOpen]);

  return (
    <>
      <Backdrop className={classes.backdrop} open={isBackdropOpen || isOpen}>
        <Card className={classes.card}>
          <CircularProgress color="inherit" />
        </Card>
      </Backdrop>
    </>
  );
}
